import axios from 'axios';
import { ENDPOINTS } from '../constants';

export type TGetActionsResponse = string[];

export const getActions = async (): Promise<TGetActionsResponse> => {
    const res = await axios.get(`${axios.defaults.baseURL}${ENDPOINTS.getActions}`);
    return res.data;
};

export interface IApplyActionParams {
    challengeId: string;
    action: string;
}

export const applyAction = async (params: IApplyActionParams): Promise<void> => {
    await axios.post(`${axios.defaults.baseURL}${ENDPOINTS.applyAction}`, {}, { params: params });
};
